import { useEffect } from "react";
import { useQrReader } from './useQrReader';
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const QrCodeScanner = ({ style, onScanSuccess }) => {
    const { t } = useTranslation();
    // const [allowSend, setAllowSend] = useState(true);
    // const [deviceId, setDeviceId] = useState(null);

    // useEffect(() => {
    //     navigator.mediaDevices?.enumerateDevices().then(devices => {
    //         const videoDevices = devices?.filter(device => device.kind === "videoinput");
    //         if (videoDevices?.length > 0) {
    //             setDeviceId(videoDevices[0].deviceId); // Set first available camera
    //         } else {
    //             console.error("No camera found.");
    //         }
    //     });
    // }, []);

    const { ref, startQrReader, stopQrReader, permissionStatus, CAMERA_STATUS } = useQrReader({
        timeBetweenDecodingAttempts: 500, // Adjust scan interval
        // constraints: { video: { facingMode: "user" } }, // Use front camera

        onResult: (result) => {
            onScanSuccess(result.getText())
            // console.log("QR Code Scanned:", result.getText());
        },
        // onError: (error) => {
        //     console.error("QR Code Error:", error);
        // },
    });

    useEffect(() => {
        startQrReader();

        return () => {
            stopQrReader();

            if (ref.current) {
                ref.current.pause();
                ref.current.src = null;
            }
        }
    }, []);

    // Helper function to get key by value from an object
    const getKeyByValue = (object, value) => {
        return Object.keys(object).find(key => object[key] === value);
    };

    return (
        <Stack
            width={'100%'}
            height={'100%'}
            justifyContent={'center'}
            alignItems={'center'}
        >
            {permissionStatus && (
                <Typography variant="h5" color="white">
                    {t(getKeyByValue(CAMERA_STATUS, permissionStatus.code))}
                </Typography>
            )}

            <video
                sx={{
                    width: '100%',
                    height: '100%',
                }}
                ref={ref}
                style={style}
            />
        </Stack>
    )
}

export default QrCodeScanner